import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { CCDeclinedReport, Store, AppState } from '../../../../store';

@Component({
  selector: 'app-declined-report',
  templateUrl: './declined-report.component.html',
  styleUrls: ['./declined-report.component.css']
})
export class DeclinedReportComponent extends ReportBase implements OnInit {

  report: CCDeclinedReport;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'dateDeclined', type: 'date', title: 'Date' },
    { name: 'teamGroup', type: 'text', title: 'Team' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'cardtype', type: 'select', title: 'Card Type', options: [] },
    { name: 'declinedReason', type: 'text', title: 'Reason' },
    { name: 'amountDeclined', type: 'number', title: 'Credit' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getDeclinedCreditCardReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/declined-report/declined-report.component.ts